import { useRef, useState } from "react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const LABELS = { equipos: "Equipos", atletas: "Atletas", evaluaciones: "Evaluaciones", documentos: "Documentos", calidadDatos: "Calidad de datos", registros: "Registros (formularios)" };

const Resumen = ({ r }) => (
  <div className="wrapx">
    <table className="tbl" data-testid="import-summary-table">
      <thead><tr><th>Colección</th><th>Registros</th><th>Nuevos</th><th>Se actualizan</th><th>Omitidos</th></tr></thead>
      <tbody>
        {Object.entries(r).map(([k, v]) => (
          <tr key={k} data-testid={`import-row-${k}`}><td>{LABELS[k]}</td><td>{v.total}</td><td>{v.nuevos}</td><td>{v.actualizados}</td><td>{v.omitidos}</td></tr>
        ))}
      </tbody>
    </table>
    {r.registros?.porPlantilla && (
      <p className="note" style={{ marginTop: 10 }} data-testid="import-por-plantilla">Registros por plantilla: {Object.entries(r.registros.porPlantilla).map(([k, v]) => `${k}: ${v}`).join(" · ")}</p>
    )}
  </div>
);

export const ImportData = () => {
  const input = useRef(null);
  const [payload, setPayload] = useState(null);
  const [name, setName] = useState("");
  const [preview, setPreview] = useState(null);
  const [busy, setBusy] = useState(false);

  const reset = () => { setPayload(null); setPreview(null); setName(""); if (input.current) input.current.value = ""; };

  const pick = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const json = JSON.parse(await file.text());
      const { data } = await api.post("/admin/import", json, { params: { confirmar: false } });
      setPayload(json); setName(file.name); setPreview(data.resumen);
    } catch (err) {
      toast.error(err instanceof SyntaxError ? "El archivo no es un JSON válido" : errMsg(err));
      reset();
    } finally { setBusy(false); }
  };

  const confirm = async () => {
    setBusy(true);
    try {
      const { data } = await api.post("/admin/import", payload, { params: { confirmar: true } });
      const total = Object.values(data.resumen).reduce((s, v) => s + v.total, 0);
      toast.success(`Importación completa: ${total} registros cargados`);
      reset();
    } catch (err) { toast.error(errMsg(err)); }
    finally { setBusy(false); }
  };

  const total = preview ? Object.values(preview).reduce((s, v) => s + v.total, 0) : 0;

  return (
    <div className="panel" data-testid="import-panel">
      <h4>Importar datos (JSON)</h4>
      <p className="note">Carga el archivo once-y-once-datos-v2.json (claves: equipos, atletas, evaluaciones, documentos, calidadDatos y registros). Los registros se actualizan por “id”, así que importar de nuevo no crea duplicados.</p>
      <input ref={input} type="file" accept="application/json,.json" onChange={pick} disabled={busy} style={{ display: "none" }} data-testid="import-file-input" />
      {!preview && <button className="btn btn-sol" onClick={() => input.current?.click()} disabled={busy} data-testid="import-pick-btn">{busy ? "Leyendo archivo…" : "Importar datos (JSON)"}</button>}
      {preview && (
        <div data-testid="import-preview">
          <p style={{ margin: "6px 0 10px" }}><b>{name}</b>: se van a cargar <b data-testid="import-total">{total}</b> registros.</p>
          <Resumen r={preview} />
          <div style={{ display: "flex", gap: 10, marginTop: 14, flexWrap: "wrap" }}>
            <button className="btn btn-sol" onClick={confirm} disabled={busy} data-testid="import-confirm-btn">{busy ? "Importando…" : "Confirmar importación"}</button>
            <button className="btn" style={{ background: "#1E4F87", color: "#fff" }} onClick={reset} disabled={busy} data-testid="import-cancel-btn">Cancelar</button>
          </div>
        </div>
      )}
    </div>
  );
};
